import { PageMeta } from 'types/Pages'

export const PageMetaSetting: PageMeta = {
  location: '/users/laboratory-agent/new',
  title: 'Cadastro Agente Laboratório',
  endpoint: '/app/person',
}
